// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { SiteModelBaseElement } from './SiteModelBaseElement';
import { Website } from './Website';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 栏目 实体类
 * 网站的栏目，分为二级主子栏目。通过IsVisiable可以控制栏目是否显示
 */
export class Column extends SiteModelBaseElement {
  /** 编码 : 同一网站下下唯一，建议采用栏目编码-子栏目编码的结构 */
  private _code: string;

  /** 设置：编码 */
  public get code() {
    return this._code;
  }

  /** 获取：编码 */
  public set code(value: string) {
    this._code = value;
  }

  /** 是否可见 : 栏目是否可见 */
  private _isVisiable: boolean;

  /** 设置：是否可见 */
  public get isVisiable() {
    return this._isVisiable;
  }

  /** 获取：是否可见 */
  public set isVisiable(value: boolean) {
    this._isVisiable = value;
  }

  /** 标题 : 栏目的标题，用于Meta的Title */
  private _metaTitle: string;

  /** 设置：标题 */
  public get metaTitle() {
    return this._metaTitle;
  }

  /** 获取：标题 */
  public set metaTitle(value: string) {
    this._metaTitle = value;
  }

  /** 关键词 : 栏目关键词，建议不超过2个词，中间用半角逗号分隔，用于Meta的Keywords */
  private _metaKeywords: string;

  /** 设置：关键词 */
  public get metaKeywords() {
    return this._metaKeywords;
  }

  /** 获取：关键词 */
  public set metaKeywords(value: string) {
    this._metaKeywords = value;
  }

  /** 元描述 : 栏目描述，对应meta的description */
  private _metaDescription: string;

  /** 设置：元描述 */
  public get metaDescription() {
    return this._metaDescription;
  }

  /** 获取：元描述 */
  public set metaDescription(value: string) {
    this._metaDescription = value;
  }

  /** 栏目页面地址 : 栏目点击以后的跳转页面地址 */
  private _url: string;

  /** 设置：栏目页面地址 */
  public get url() {
    return this._url;
  }

  /** 获取：栏目页面地址 */
  public set url(value: string) {
    this._url = value;
  }

  /** 是否弹出 : 栏目点击以后跳转页面是否弹出，默认不弹出 */
  private _isBlank: boolean;

  /** 设置：是否弹出 */
  public get isBlank() {
    return this._isBlank;
  }

  /** 获取：是否弹出 */
  public set isBlank(value: boolean) {
    this._isBlank = value;
  }

  /** 网站 的ID */
  private _website_ID: string;

  /** 获取：网站 的ID */
  public get website_ID() {
    return this._website_ID;
  }

  /** 设置：网站 的ID */
  public set website_ID(value: string) {
    this._website_ID = value;
  }

  /** 网站  */
  private _website: Website;

  /** 获取：网站  */
  public get website() {
    return this._website;
  }

  /** 设置：网站  */
  public set website(value: Website) {
    this._website = value;
    if (value !== null) {
      this.website_ID = value.id;
    } else {
      this.website_ID = '';
    }
  }

  /** 主栏目 的ID */
  private _parent_ID: string;

  /** 获取：主栏目 的ID */
  public get parent_ID() {
    return this._parent_ID;
  }

  /** 设置：主栏目 的ID */
  public set parent_ID(value: string) {
    this._parent_ID = value;
  }

  /** 主栏目  */
  private _parent: Column;

  /** 获取：主栏目  */
  public get parent() {
    return this._parent;
  }

  /** 设置：主栏目  */
  public set parent(value: Column) {
    this._parent = value;
    if (value !== null) {
      this.parent_ID = value.id;
    } else {
      this.parent_ID = '';
    }
  }

  /** 子栏目 */
  private _children: Array<Column>;

  /** 获取：子栏目 */
  public get children() {
    return this._children;
  }

  /** 设置：子栏目 */
  public set children(value: Array<Column>) {
    this._children = value;
  }

  constructor() {
    super();
    this._code = '';
    this._isVisiable = false;
    this._metaTitle = '';
    this._metaKeywords = '';
    this._metaDescription = '';
    this._url = '';
    this._isBlank = false;
    this._website_ID = '';
    this._website = null;
    this._parent_ID = '';
    this._parent = null;
    this._children = new Array<Column>();
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: Column, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.code = element.code;
      this.isVisiable = element.isVisiable;
      this.metaTitle = element.metaTitle;
      this.metaKeywords = element.metaKeywords;
      this.metaDescription = element.metaDescription;
      this.url = element.url;
      this.isBlank = element.isBlank;
      this.website_ID = element.website_ID;
      if (hasReference && element.website !== null) {
        this.website = element.website;
      }
      this.parent_ID = element.parent_ID;
      if (hasReference && element.parent !== null) {
        this.parent = element.parent;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.code = json.Code;
    this.isVisiable = json.IsVisiable;
    this.metaTitle = json.MetaTitle;
    this.metaKeywords = json.MetaKeywords;
    this.metaDescription = json.MetaDescription;
    this.url = json.Url;
    this.isBlank = json.IsBlank;
    this.website_ID = json.Website_ID;
    // if (json.Website !== null) {
    //   this.website = Website.Create(json.Website);
    // }
    this.parent_ID = json.Parent_ID;
    // if (json.Parent !== null) {
    //   this.parent = Column.Create(json.Parent);
    // }
    if (json.Children && json.Children.length > 0) {
      json.Children.forEach((element: any) => {
        const column = Column.Create(element);
        // column.parent = this;
        this.children.push(column);
      });
    }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Code = this.code;
    json.IsVisiable = this.isVisiable;
    json.MetaTitle = this.metaTitle;
    json.MetaKeywords = this.metaKeywords;
    json.MetaDescription = this.metaDescription;
    json.Url = this.url;
    json.IsBlank = this.isBlank;
    json.Website_ID = this.website_ID;
    json.Parent_ID = this.parent_ID;
    if (this.children && this.children.length > 0) {
      json.Children = [];
      this.children.forEach((element) => {
        json.Children.push(element.toJson());
      });
    }
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('基本属性', 'code', '编码', EnumDataType.String, this.code, true, '同一网站下下唯一，建议采用栏目编码-子栏目编码的结构', '', '');
    context.addRow('基本属性', 'isVisiable', '是否可见', EnumDataType.Bool, this.isVisiable, true, '栏目是否可见', '', '');
    context.addRow('SEO属性', 'metaTitle', '标题', EnumDataType.String, this.metaTitle, true, '栏目的标题，用于Meta的Title', '', '');
    context.addRow('SEO属性', 'metaKeywords', '关键词', EnumDataType.String, this.metaKeywords, true, '栏目关键词，建议不超过2个词，中间用半角逗号分隔，用于Meta的Keywords', '', '');
    context.addRow('SEO属性', 'metaDescription', '元描述', EnumDataType.String, this.metaDescription, true, '栏目描述，对应meta的description', '', '');
    context.addRow('基本属性', 'url', '栏目页面地址', EnumDataType.String, this.url, true, '栏目点击以后的跳转页面地址', '', '');
    context.addRow('基本属性', 'isBlank', '是否弹出', EnumDataType.Bool, this.isBlank, true, '栏目点击以后跳转页面是否弹出，默认不弹出', '', '');
    return context;
  }

  static Create(json: any): Column {
    const column = new Column();
    column.Deserialize(json);
    column.json = json;
    return column;
  }
}
